import { NotLoggedInMasterComponent } from './layout/not-loggedin/not-loggedin.master';
import { FooterComponent } from './layout/footer/footer.master';
import { MainLayoutEffects } from './layout/main/effects';
import { HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { CIRTRoutingModule } from './cirt-routing.module';
import { featureKey, reducers } from './store/cirt.reducers';
import { MainMasterComponent } from './layout/main/main.master';
import { MaterialModule } from 'src/app/app.material.module';
import { IfaaUiComponentsModule } from '@ifaa-components/ui-components';
import { MemberPortalSharedModule } from '../shared/shared.module';
import { TenantDashboardComponent } from './views/dashboard/dashboard.component';
import { TenantJetcoComponent } from './views/jetco/jetco/jetco.component';
import { TenantJetcoApprovedTrainingComponent } from './views/jetco/approved-training/approved-training.component';
import { TenantJetcoLodgeClaimComponent } from './views/jetco/lodge-claim/lodge-claim.component';
import { JetcoLodgeClaimEffects } from './views/jetco/lodge-claim/effects';
import { JetcoService } from './services/jetco.service';
import { EmploymentHistoryViewComponent } from './views/employment-history/employment-history-view.component';
import { EmployerHistoryViewEffects } from './views/employment-history/effects';
import { TenantLodgeClaimComponent } from './views/lodge-claim/lodge-claim.component';
import { LodgeClaimEffects } from './views/lodge-claim/effects';
import { LodgeClaimService } from './services/lodge-claim.service';
import { JetcoClaimAmountEffects } from './components/jetco-claim-amount/effects';

import { CurrentEmployerViewComponent } from './components/current-employer/current-employer/current-employer-view.component';
import { EmployerBalancesComponent } from './components/employer-balances/employer-balances.component';
import { EmployerBalancesEffects } from './components/employer-balances/effects';
import { JetcoClaimComponent } from './components/jetco-claim-amount/jetco-claim-amount.component';
import { EmploymentService } from './services/employment.service';
import { CurrentEmployerEffects } from './components/current-employer/current-employer/effects';
import { GreenIdEffects } from './components/greenid/effects';
import { GreenIdService } from './services/greenid.service';
import { GreenIdComponent } from './components/greenid/greenid.component';
import { GreenIdDocsVerificationDialog } from './components/greenid/docs-verification-dialog/docs-verification-dialog.component';
import { GreenIdConsentDialog } from './components/greenid/consent-dialog/consent-dialog.component';


@NgModule({
  declarations: [
    MainMasterComponent,
    FooterComponent,
    NotLoggedInMasterComponent,
    TenantDashboardComponent,
    CurrentEmployerViewComponent,
    TenantJetcoComponent,
    TenantJetcoApprovedTrainingComponent,
    TenantJetcoLodgeClaimComponent,
    TenantLodgeClaimComponent,
    EmploymentHistoryViewComponent,
    JetcoClaimComponent,
    EmployerBalancesComponent,
    GreenIdComponent,
    GreenIdDocsVerificationDialog,
    GreenIdConsentDialog
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    CIRTRoutingModule,
    HttpClientModule,
    MaterialModule,
    IfaaUiComponentsModule,
    StoreModule.forFeature(featureKey, reducers),
    EffectsModule.forFeature([
      MainLayoutEffects,
      JetcoLodgeClaimEffects,
      CurrentEmployerEffects,
      LodgeClaimEffects,
      EmployerHistoryViewEffects,
      JetcoClaimAmountEffects,
      EmployerBalancesEffects,
      GreenIdEffects
    ]),
    MemberPortalSharedModule,

  ],
  exports: [
    MainMasterComponent,
    NotLoggedInMasterComponent,
    TenantDashboardComponent,
    CurrentEmployerViewComponent,
    TenantJetcoComponent,
    TenantJetcoApprovedTrainingComponent,
    TenantJetcoLodgeClaimComponent,
    EmploymentHistoryViewComponent,
    TenantLodgeClaimComponent,
    JetcoClaimComponent,
    EmployerBalancesComponent,
    GreenIdComponent,
    GreenIdDocsVerificationDialog
  ],
  providers: [
    JetcoService,
    LodgeClaimService,
    EmploymentService,
    GreenIdService
  ]
})
export class CIRTModule { }
